import i18n from "i18next";
import * as React from "react";
import { Configuration, BaseAPI } from "../api";

import { useAuth } from "../contexts/AuthContext";

export let baseUrl =
  (document.getElementById("_baseUrl") as HTMLInputElement)?.value || "~";
console.log("Base url is " + baseUrl);

if (baseUrl === "~") {
  const hostUrl = window.location.href.split("/");
  baseUrl = hostUrl[0] + "//" + hostUrl[2];
}

export function useApiService<T extends BaseAPI>(
  type: new (configuration: Configuration) => T,
  transformRequest?: (request: RequestInit) => RequestInit
): T {
  const { logout, getAccessToken } = useAuth();

  const configuration = React.useMemo(() => {
    const cfg: Configuration = {
      basePath: baseUrl,
      apiKeyPromise: getAccessToken,
      headers: {
        "Accept-Language": i18n.language,
      },
      middlewares: [
        {
          pre(request) {
            const result = transformRequest
              ? transformRequest(request)
              : request;
            return Promise.resolve(result);
          },
          post(response) {
            if (response.status === 401) {
              logout();
            }
            return Promise.resolve(response);
          },
        },
      ],
    };

    return cfg;
  }, [getAccessToken, transformRequest, logout]);
  return React.useMemo(() => new type(configuration), [configuration, type]);
}
